const languageCodes = {
    'fr_BE': 'fr_BE',
    'nl_BE': 'nl_BE',
    'fr-BE': 'fr_BE',
    'nl-BE': 'nl_BE',
    'nl_NL': 'nl_NL',
    'nl-NL': 'nl_NL',
};

export default languageCodes;